<template>
    <div id="calendarFilter">
        <div class="d-flex justify-content-center mb-3 w-100">
            <div class="btn-group btn-group-lg" role="group" aria-label="Button group with nested dropdown">
                <button id="customDateBtn" class="btn btn-xs rounded-r-m brand-bg-color text-white"><i class="fa fa-calendar"></i></button>
                <div v-if="selectedDate!=null" class="font-weight-bold rounded brand-bg-color d-flex align-items-center px-3 text-white">{{selectedDate}}</div>
                <div v-else class="font-weight-bold rounded brand-bg-color d-flex align-items-center px-3 text-white">همه</div>

                <button id="dropdownMenuButton" type="button" class="btn btn-xs rounded-l-m brand-bg-color dropdown-toggle text-white" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" id="dropdownMenuCalDiv">
                    <button class="dropdown-item" @click.prevent="FilterCalendar(1)">روز </button>
                    <button class="dropdown-item" @click.prevent="FilterCalendar(2)">ماه </button>
                    <button class="dropdown-item" @click.prevent="FilterCalendar(3)">سال </button>
                    <button class="dropdown-item" @click.prevent="showAllDate">همه</button>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between">
            <button v-if="mode==1" class="btn btn-link brand-color px-1" title="هفته قبل" @click="moveCalendar(-1)"><i class="fa fa-chevron-right"></i></button>
            <ul class="nav nav-pills" id="tab-cal">
                <li v-for="d in dayList" :key="d.date" class="nav-item" role="presentation">
                    <button class="nav-link text-center calendar-filter-item" data-toggle="pill" :id="d.date.replace('/', '').replace('/', '').replace('/', '')" :class="{'active isSelectDate' : d.selected===true}" @click.prevent="selectDate(d)">
                        <span class="d-block line-height-s">{{d.title}}</span>
                        <span v-if="d.displayDate!=null && d.displayDate!=''" class="d-block line-height-s">{{d.displayDate}}</span>
                    </button>
                </li>
            </ul>
            <button v-if="mode==1" class="btn btn-link brand-color px-1" title="هفته بعد" @click="moveCalendar(1)"><i class="fa fa-chevron-left"></i></button>
        </div>
        <date-picker type="date" v-model="selectedDate" format="jYYYY/jMM/jDD" element="customDateBtn" @change="refreshList" />
    </div>
</template>


<script>
    import DatePicker from 'vue3-persian-datetime-picker';

    export default {
        components: {
            DatePicker,
        },
        data() {
            return {
                dayList: [],
                selectedDate: null,
                mode: 1,
                move: 0,
                firstLoad: false
            }
        },
        methods: {
            FilterCalendar(mode) {
                this.mode = mode;
                this.getDayList();
                document.getElementById("dropdownMenuCalDiv").classList.remove("show");
            },
            moveCalendar(val) {
                this.move = this.move + val;
                this.getDayList();
            },
            showAllDate() {
                this.selectedDate = null;
                this.$emit('selectDate', null);
                document.getElementById("dropdownMenuCalDiv").classList.remove("show");
            },
            selectDate(d) {
                this.selectedDate = d.date;
                this.$emit('selectDate', d.date);
            },
            refreshList() {
                this.move = 0;
                this.getDayList();
                this.$emit('selectDate', this.selectedDate);
            },
            getDayList(isFirst = false) {
                this.$http.get("CheckList/GetCalendarItemList", {
                    params: {
                        date: this.selectedDate,
                        mode: this.mode,
                        move: this.move
                    }
                }).then(data => {
                    this.dayList = data.data;
                    var elmnt = document.getElementsByClassName('active');
                    if (elmnt.length > 0 && this.firstLoad == false) {

                        elmnt[0].scrollIntoView();
                        this.firstLoad = true;
                    }
                    let id = "";
                    for (var i = 0; i < data.data.length; i++) {
                        if (data.data[i].selected) {
                            id = data.data[i].date.replace('/', '').replace('/', '').replace('/', '');
                        }
                    }
                    setTimeout(function () {
                        if (id != null && id != "") {
                            let e = document.getElementById(id);
                            if (!isFirst)
                                e.click();
                            e.scrollIntoView();
                        }
                    }, 500);
                })
            }
        },
        props: ["defaultDate"],
        created() {
            this.getDayList(true);
        }
    }
</script>
